<template>
  <div>
    <div v-if="isKolor"
         class="ticket-values">
      <div class="value"
           :style="{'background-color': getKolorColor(betValues[0].color)}">
      </div>
    </div>
    <div v-else
         class="ticket-values">
      <div class="value"
           v-for="value in betValues"
           :key="value.number"
           :style="{'background-color': value.color}">
        <span>{{value.number}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import betParser from '../utility/betParser';

export default {
  name: 'TableBetValues',
  props: {
    betValues: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters([
      'isKolor',
    ]),
  },
  methods: {
    getKolorColor(value) {
      return betParser.parseKolorColor(value);
    },
  },
};
</script>
<style lang="scss" scoped>
.ticket-values {
  width: 150px;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  margin: 0 auto;
  .value {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    margin-left: 2px;
  }
  span {
    color: #fff;
  }
  :nth-child(n+7) {
    margin-top: 2px;
  }
}
</style>
